import { CONSTANT } from '../ObjectSegOperatorTypes';
const toConstantFilter = operator => {
  return {
    filterType: CONSTANT,
    shouldAccept: operator.value
  };
};
export default toConstantFilter;